import React, {useState} from 'react'
import './Sliders.scss'
import Slider from './Slider'

const Sliders = props => {

    const data = props.data || {
        header:"Using the Answers to These Questions",
        setupText:"Here’s what you discovered. Based on this information, how credible do you think each of these sources are?",
        sourceText:[" <h2> Bigfoot Research </h2> <p> Who’s behind the information? </p> <ul> <li> A self-published and denounced researcher </li> </ul> <p> What’s the evidence? </p> <ul> <li> A list of unsubstantiated facts, a graph, and an unverified image </li> </ul> <p> What do other sources say? </p> <ul> <li> There is no conclusive evidence that Bigfoot exists </li> </ul> ",
        "<h2> Explore the Wild </h2> <p> Who’s behind the information? </p> <ul> <li> A fitness blogger </li> </ul> <p> What’s the evidence? </p> <ul> <li> A chart and a link to a study </li> </ul> <p> What do other sources say? </p> <ul> <li> Reputable studies support the idea that regular time in nature is associated with higher levels of wellbeing </li> </ul>"],
        titleText:[
            " <h2> Bigfoot Research </h2>",
            "<h2> Explore the Wild </h2>"
        ],
        labels:[
            "Very credible",         
            "Undecided",         
            "Not credible at all",
        ]
    }

    const handleNext = () => {
        setPhase('review')
        // props.onComplete();
    }

    const [phase, setPhase] = useState('select');
    
    return (
        <div className={`Sliders ${phase}`}>
            {/* <div className={`debug`}>{
                JSON.stringify(data)
            }</div> */}

            <div className={`header`} dangerouslySetInnerHTML={{__html:data.header}}></div>            
            {
                (data.sourceText) && <div className={`source`}>
                    <div className={`side-titles`}>
                        <div className={`title title-a`} dangerouslySetInnerHTML={{__html:data.titleText[0]}}></div>
                        <div className={`title title-b`} dangerouslySetInnerHTML={{__html:data.titleText[1]}}></div>
                    </div>
                    <div className={`text`} dangerouslySetInnerHTML={{__html:data.sourceText}}></div>
                </div>
                
            }
            <div className={`instructions`} dangerouslySetInnerHTML={{__html:data.instructions}}></div>

           <div className="bottom-wrapper">
                <div className={`slider-titles`}>
                    <div className={`title title-a`} dangerouslySetInnerHTML={{__html:data.titleText[0]}}></div>
                    <div className={`title title-b`} dangerouslySetInnerHTML={{__html:data.titleText[1]}}></div>
                    <div className="stanford_icon"></div>
                </div>
                <Slider className="slider-a" labels={data.labels} />
                <Slider className="slider-b" labels={data.labels} />
    
                {phase === 'select' && <div id={'submit-btn'} className={`global-button submit`} onClick={handleNext}>Submit</div>}
                {phase === 'review' && <div className={`pager-data`} ><div className={`text-content`} dangerouslySetInnerHTML={{__html:data.pager}}></div>
                <div className={`next-button global-button`} onClick={props.onComplete}>Next</div></div>}
           </div > 
            <datalist id="options" className="range__list">
                {
                    data.labels && data.labels.map((option, optionIndex) => {
                        return <option className={"range__opt"} key={`option-${optionIndex}`} label={option}>{optionIndex}</option>
                    })
                }
            </datalist>
        </div>
    )
}

export default Sliders